import { useSelector } from "react-redux"
import { WinnersPopup } from "./WinnersPopup"
import { closeShopWinnersPopup } from "../../redux/actions"

export const ShopWinnersPopup = () => {
    const id = useSelector(state => state.game.gameShop.settings?.id)
    const allWinners = useSelector(state => state.game.allShopWinners)
    const pagination = useSelector(state => state.game.shopPagination)
    const winners = useSelector(state => state.game.gameShop.winners)
    const winnersPopup = useSelector(state => state.game.shopWinnersPopup)
    const lang = useSelector(state => state.app.currentLang)

    if (!winnersPopup) return (null)

    return (
        <WinnersPopup
            id={id}
            winners={winners}
            allWinners={allWinners}
            pagination={pagination}
            game='shop'
            close={closeShopWinnersPopup}
            title={lang.shop.title}
        />
    )
}